import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { toast } from "shared/ui/shadcn/sonner";

import { useApiClient } from "@/context/api-client";

export const useQueryFetchCalendlyURI = (
  campaignId: string | undefined,
  accountId: string | undefined,
  isEnabled: boolean = true
) => {
  const apiClient = useApiClient();

  const query = useQuery({
    enabled: !!campaignId && !!accountId && isEnabled,
    queryKey: ["calendly-account-uri", campaignId, accountId],
    queryFn: () =>
      apiClient.getAccountCalendlyUri(
        accountId as string,
        campaignId as string
      ),
    select: (data) => data?.data?.uri,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error("Failed to fetch Calendly URI");
    }
  }, [query.isError]);

  return query;
};
